function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import PrimaForm from "../PrimaForm";

var CancellationForm = function CancellationForm(props) {
  var _polizaEndorsementFor, _polizaEndorsementFor2, _polizaEndorsementFor6, _polizaEndorsementFor7;

  var poliza = props.poliza,
      polizaEndorsement = props.polizaEndorsement,
      polizaEndorsementForm = props.polizaEndorsementForm,
      onChangeDuration = props.onChangeDuration,
      onChangeAmount = props.onChangeAmount,
      cancelReasons = props.cancelReasons,
      setPolizaEndorsementForm = props.setPolizaEndorsementForm,
      _props$banks = props.banks,
      banks = _props$banks === void 0 ? [] : _props$banks;
  props;
  var defaultCancelReason = cancelReasons.find(function (reason) {
    return (polizaEndorsement === null || polizaEndorsement === void 0 ? void 0 : polizaEndorsement.cancel_reason) === reason.value;
  });

  var _React$useState = React.useState((polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor === void 0 ? void 0 : _polizaEndorsementFor.current_account_client) || "contratante"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedClient = _React$useState2[0],
      setSelectedClient = _React$useState2[1]; // Crear opciones de bancos


  var banksOption = React.useMemo(function () {
    if (!banks) {
      return [];
    } // Los bancos vienen serializados como JSON desde el controlador
    // Pueden venir como array o como string JSON que necesita parsearse


    var banksData = banks; // Si es string, parsearlo

    if (typeof banks === 'string') {
      try {
        banksData = JSON.parse(banks);
      } catch (e) {
        return [];
      }
    } // Convertir a array si no lo es


    var banksArray = Array.isArray(banksData) ? banksData : banksData ? [banksData] : [];

    if (banksArray.length === 0) {
      return [];
    }

    return banksArray.map(function (bank) {
      // Los bancos vienen con id, name, code, display_name
      var bankId = bank.id;
      var bankName = bank.name || '';
      var bankCode = bank.code || '';
      var displayName = bank.display_name || (bankCode && bankName ? "".concat(bankCode, " - ").concat(bankName) : bankName) || 'Banco sin nombre';
      return {
        label: displayName,
        value: bankId
      };
    }).filter(function (option) {
      return option.value != null && option.value !== undefined;
    });
  }, [banks]); // Verificar si debe mostrar campos de cuenta corriente (cancelación excepto no_payment)

  var shouldShowCurrentAccount = (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.cancel_reason) && polizaEndorsementForm.cancel_reason !== "no_payment"; // Obtener datos del cliente seleccionado

  var selectedClientData = selectedClient === "contratante" ? poliza.contratante : poliza.asegurado; // Obtener datos de cuenta corriente del formulario o del cliente

  var currentAccountData = (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor2 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor2 === void 0 ? void 0 : _polizaEndorsementFor2.current_account) || {};
  var bankId = currentAccountData.bank_id || (selectedClientData === null || selectedClientData === void 0 ? void 0 : selectedClientData.bank_id) || null;
  var bankName = currentAccountData.bank_name || (selectedClientData === null || selectedClientData === void 0 ? void 0 : selectedClientData.bank_name) || "";
  var accountNumber = currentAccountData.account_number || (selectedClientData === null || selectedClientData === void 0 ? void 0 : selectedClientData.bank_account_number) || "";
  var email = currentAccountData.email || (selectedClientData === null || selectedClientData === void 0 ? void 0 : selectedClientData.bank_email) || ""; // Encontrar el banco seleccionado - convertir bankId a número para comparación

  var bankIdNum = bankId ? typeof bankId === 'string' ? parseInt(bankId, 10) : bankId : null;
  var selectedBank = null;

  if (bankIdNum) {
    // Buscar por ID primero
    selectedBank = banksOption.find(function (option) {
      var optionValue = typeof option.value === 'string' ? parseInt(option.value, 10) : option.value;
      return optionValue === bankIdNum;
    }) || null;
  } // Si no se encontró por ID, buscar por nombre


  if (!selectedBank && bankName) {
    selectedBank = banksOption.find(function (option) {
      var _normalizedBankName$s;

      var label = option.label || '';
      var normalizedLabel = label.toLowerCase().trim();
      var normalizedBankName = bankName.toLowerCase().trim(); // Buscar coincidencia exacta o parcial

      return normalizedLabel === normalizedBankName || normalizedLabel.includes(normalizedBankName) || normalizedBankName.includes(normalizedLabel) || // También buscar por código (ej: "001 - Banco de Chile" contiene "001")
      normalizedBankName.match(/^\d+\s*-/) && normalizedLabel.includes(((_normalizedBankName$s = normalizedBankName.split(/\s*-/)[1]) === null || _normalizedBankName$s === void 0 ? void 0 : _normalizedBankName$s.trim()) || '');
    }) || null;
  }

  var clientOptions = [{
    value: "contratante",
    label: "Contratante"
  }, {
    value: "asegurado",
    label: "Asegurado"
  }];

  var handleCurrentAccountChange = function handleCurrentAccountChange(field, value) {
    var _polizaEndorsementFor3;

    // Use the most recent state value, not the computed currentAccountData
    var latestCurrentAccount = (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor3 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor3 === void 0 ? void 0 : _polizaEndorsementFor3.current_account) || {};

    var updatedForm = _objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
      poliza_params: _objectSpread(_objectSpread({}, polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.poliza_params), {}, {
        current_account: _objectSpread(_objectSpread({}, latestCurrentAccount), {}, _defineProperty({}, field, value)),
        current_account_client: selectedClient
      })
    });

    setPolizaEndorsementForm(updatedForm);
  };

  var handleBankChange = function handleBankChange(selectedOption) {
    var _polizaEndorsementFor4;

    // Use the most recent state value, not the computed currentAccountData
    var latestCurrentAccount = (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor4 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor4 === void 0 ? void 0 : _polizaEndorsementFor4.current_account) || {};
    setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
      poliza_params: _objectSpread(_objectSpread({}, polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.poliza_params), {}, {
        current_account: _objectSpread(_objectSpread({}, latestCurrentAccount), {}, {
          bank_id: selectedOption ? parseInt(selectedOption.value) : null,
          bank_name: selectedOption ? selectedOption.label : ""
        }),
        current_account_client: selectedClient
      })
    }));
  }; // Función para autocompletar datos de cuenta corriente


  var autocompleteCurrentAccountData = React.useCallback(function () {
    var _polizaEndorsementFor5;

    var currentAccountData = (polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor5 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor5 === void 0 ? void 0 : _polizaEndorsementFor5.current_account) || {};
    var hasExistingData = currentAccountData.bank_id || currentAccountData.account_number || currentAccountData.email; // Si ya hay datos guardados, no autocompletar

    if (hasExistingData) {
      return;
    } // Primero intentar obtener datos desde payment_information de la póliza


    var bankId = null;
    var bankName = "";
    var accountNumber = "";
    var email = ""; // Verificar si payment_information existe y tiene datos (puede estar en poliza.payment_information o poliza.payment_information)

    var paymentInfo = poliza.payment_information;

    if (paymentInfo && paymentInfo.bank_id && paymentInfo.account_number) {
      bankId = paymentInfo.bank_id;
      accountNumber = paymentInfo.account_number || ""; // Obtener el nombre del banco desde la lista de bancos

      var bankOption = banksOption.find(function (option) {
        var optionValue = typeof option.value === 'string' ? parseInt(option.value, 10) : option.value;
        return optionValue === bankId;
      });
      bankName = bankOption ? bankOption.label : ""; // Obtener email del cliente seleccionado

      var clientData = selectedClient === "contratante" ? poliza.contratante : poliza.asegurado;
      email = (clientData === null || clientData === void 0 ? void 0 : clientData.bank_email) || (clientData === null || clientData === void 0 ? void 0 : clientData.email) || "";
    } else {
      // Si no hay payment_information, intentar desde el cliente
      var _clientData = selectedClient === "contratante" ? poliza.contratante : poliza.asegurado;

      if (_clientData && (_clientData.bank_id || _clientData.bank_account_number || _clientData.bank_email)) {
        bankId = _clientData.bank_id || null;
        bankName = _clientData.bank_name || "";
        accountNumber = _clientData.bank_account_number || "";
        email = _clientData.bank_email || "";
      }
    } // Solo autocompletar si se encontraron datos


    if (bankId || accountNumber || email) {
      setPolizaEndorsementForm(function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          poliza_params: _objectSpread(_objectSpread({}, prevForm === null || prevForm === void 0 ? void 0 : prevForm.poliza_params), {}, {
            current_account: {
              bank_id: bankId,
              bank_name: bankName,
              account_number: accountNumber,
              email: email
            },
            current_account_client: selectedClient
          })
        });
      });
    }
  }, [polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor6 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor6 === void 0 ? void 0 : _polizaEndorsementFor6.current_account, poliza, selectedClient, banksOption, setPolizaEndorsementForm]); // Autocompletar datos bancarios cuando se selecciona una razón de cancelación (excepto no_payment)

  React.useEffect(function () {
    if (shouldShowCurrentAccount) {
      autocompleteCurrentAccountData();
    }
  }, [polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.cancel_reason, shouldShowCurrentAccount, autocompleteCurrentAccountData]);

  var handleClientChange = function handleClientChange(option) {
    var newClient = option.value;
    setSelectedClient(newClient); // Cargar datos del nuevo cliente seleccionado

    var newClientData = newClient === "contratante" ? poliza.contratante : poliza.asegurado; // Primero intentar desde payment_information si el cliente es el contratante

    var bankId = null;
    var bankName = "";
    var accountNumber = "";
    var email = "";
    var paymentInfo = poliza.payment_information;

    if (newClient === "contratante" && paymentInfo && paymentInfo.bank_id && paymentInfo.account_number) {
      bankId = paymentInfo.bank_id;
      accountNumber = paymentInfo.account_number || ""; // Obtener el nombre del banco desde la lista de bancos

      var bankOption = banksOption.find(function (option) {
        var optionValue = typeof option.value === 'string' ? parseInt(option.value, 10) : option.value;
        return optionValue === bankId;
      });
      bankName = bankOption ? bankOption.label : "";
      email = (newClientData === null || newClientData === void 0 ? void 0 : newClientData.bank_email) || (newClientData === null || newClientData === void 0 ? void 0 : newClientData.email) || "";
    } else if (newClientData && (newClientData.bank_id || newClientData.bank_account_number || newClientData.bank_email)) {
      // Si no hay payment_information, usar datos del cliente
      bankId = newClientData.bank_id || null;
      bankName = newClientData.bank_name || "";
      accountNumber = newClientData.bank_account_number || "";
      email = newClientData.bank_email || "";
    } // Actualizar el formulario con los datos encontrados o limpiar si no hay datos


    setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
      poliza_params: _objectSpread(_objectSpread({}, polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : polizaEndorsementForm.poliza_params), {}, {
        current_account: {
          bank_id: bankId,
          bank_name: bankName,
          account_number: accountNumber,
          email: email
        },
        current_account_client: newClient
      })
    }));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Inicio vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    maxDate: poliza.finish_date,
    selected: poliza.start_date,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fecha Cancelaci\xF3n"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    minDate: poliza.start_date,
    selected: polizaEndorsementForm === null || polizaEndorsementForm === void 0 ? void 0 : (_polizaEndorsementFor7 = polizaEndorsementForm.poliza_params) === null || _polizaEndorsementFor7 === void 0 ? void 0 : _polizaEndorsementFor7.finish_date,
    onChange: function onChange(item) {
      onChangeDuration({
        finish_date: item
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Raz\xF3n de cancelaci\xF3n"), /*#__PURE__*/React.createElement(Select, {
    options: cancelReasons,
    defaultValue: defaultCancelReason,
    isSearchable: true,
    placeholder: "Selecciona raz\xF3n de cancelaci\xF3n...",
    onChange: function onChange(item) {
      return setPolizaEndorsementForm(_objectSpread(_objectSpread({}, polizaEndorsementForm), {}, {
        cancel_reason: item.value
      }));
    }
  }))), shouldShowCurrentAccount && /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      marginTop: "20px",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("strong", null, "Datos Cuenta Corriente")), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Cliente"), /*#__PURE__*/React.createElement(Select, {
    options: clientOptions,
    value: clientOptions.find(function (opt) {
      return opt.value === selectedClient;
    }),
    onChange: handleClientChange,
    isSearchable: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Banco"), /*#__PURE__*/React.createElement(Select, {
    options: banksOption,
    value: selectedBank,
    placeholder: banksOption.length > 0 ? "Seleccione un banco..." : "Cargando bancos...",
    onChange: handleBankChange,
    isClearable: true,
    isSearchable: true,
    noOptionsMessage: function noOptionsMessage() {
      return "No hay bancos disponibles";
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nro. Cuenta"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    value: accountNumber,
    onChange: function onChange(e) {
      return handleCurrentAccountChange("account_number", e.target.value);
    },
    placeholder: "Ingrese n\xFAmero de cuenta"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Email"), /*#__PURE__*/React.createElement("input", {
    type: "email",
    className: "form-control",
    value: email,
    onChange: function onChange(e) {
      return handleCurrentAccountChange("email", e.target.value);
    },
    placeholder: "Ingrese email"
  }))))))), /*#__PURE__*/React.createElement(PrimaForm, {
    canModify: true,
    poliza: poliza,
    polizaEndorsementForm: polizaEndorsementForm,
    onChangeAmount: onChangeAmount
  }));
};

export default CancellationForm;